export const createDropDownItems = (selectedKeys, handleOnChange) => {
    return [
        {
            className: 'cursor-default align-left text-xs',
            title: 'Показать версии РИГИС',
            itemKey: 'header',
            overrideClassName: true,
            disableHover: true,
        },
        {
            type: 'checkbox',
            onChange: handleOnChange,
            checked: Object.values(selectedKeys).every(v => v.checked),
            title: 'Выбрать все',
            itemKey: 'selectAll',
            indeterminate:
                Object.values(selectedKeys).filter(key => key.checked).length > 0 &&
                Object.values(selectedKeys).length > Object.values(selectedKeys).filter(key => key.checked).length,
        },
        {
            type: 'divider',
        },
        {
            onChange: handleOnChange,
            checked: selectedKeys.system.checked,
            title: selectedKeys.system.title,
            itemKey: selectedKeys.system.itemKey,
            type: 'checkbox',
        },
        {
            type: 'divider',
        },
        {
            onChange: handleOnChange,
            checked: selectedKeys.isPrivate.checked,
            title: selectedKeys.isPrivate.title,
            itemKey: selectedKeys.isPrivate.itemKey,
            type: 'checkbox',
        },
        {
            onChange: handleOnChange,
            checked: selectedKeys.common.checked,
            title: selectedKeys.common.title,
            itemKey: selectedKeys.common.itemKey,
            type: 'checkbox',
        },
        {
            onChange: handleOnChange,
            checked: selectedKeys.readOnly.checked,
            title: selectedKeys.readOnly.title,
            itemKey: selectedKeys.readOnly.itemKey,
            type: 'checkbox',
        },
    ];
};

export const filterItems = {
    system: { itemKey: 'system', title: 'Системные', checked: true },
    isPrivate: { title: 'Сводные личные', itemKey: 'isPrivate', checked: true },
    common: { title: 'Сводные общие', itemKey: 'common', checked: true },
    readOnly: { title: 'Сводные только для чтения', itemKey: 'readOnly', checked: true },
};
